import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Bisac } from '../../../models/Bisac';

@Component({
  selector: 'app-bisac-selector',
  templateUrl: './bisac-selector.component.html',
  styleUrls: ['./bisac-selector.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BisacSelectorComponent),
      multi: true
    }
  ]
})
export class BisacSelectorComponent implements OnInit {
  public selectedBisac: Bisac;

  @Input() eraseable: boolean;
  @Output() removeNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() { }

  onBisacChange(e) {
    // console.log(e)
     this.propagateChange(this.toModel());
  }

  toModel() {
    return this.selectedBisac ? {
      codice: this.selectedBisac.codice,
      descrizione: this.selectedBisac.descrizione,
    } : {}
  }

  eraseMe() {
    this.removeNotify.emit();
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Bisac) {
    // console.log('BisacSelectorComponent - writeValue', obj)
    // if(obj)
    this.selectedBisac = obj;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/book/bisac-selector/bisac-selector.component.ts